const state = {
    enabled: false,
    show: false,
    items: [],
    instances: [],
    currentInstance: undefined,
    activeRouter: undefined,
};

const mutations = {
    enableLeftMenu(state) {
      /**
       * Включает и показывает левое меню
       */
        state.enabled = true;
        state.show = true;
    },
    dissable(state) {
      /**
       * Полностью отключает левое меню
       */
        state.enabled = false;
        state.show = false;
    },
    show(state) {
      /**
       * Показывает левое меню
       */
        state.show = true;
    },
    hide(state) {
      /**
       * Скрывает левое меню
       */
        state.show = false;
    },
    toggleVisible(state) {
      /**
       * Переключает видимость левого меню
       */
        state.show = !state.show;
    },
    replaceItems(state, items) {
      /**
       * Заменяет все элементы меню новым набором
       */
        state.items = items
    },
    replaceInstances(state, instances) {
      /**
       * Заменяет все экземпляры меню новым набором
       * @param {Array} instances - Новый массив экземпляров меню
       */
        state.instances = instances;
    },
    addItem(state, item) {
      /**
       * Добавляет один элемент в меню
       * @param {Object} item - Элемент меню для добавления
       */
        state.items.push(item)
    },
    appendItems(state, items) {
      /**
       * Добавляет несколько элементов в меню
       * @param {Array} items - Массив элементов для добавления
       */
        state.items.push(...items)
    },
    appendItem(state, item) {
      /**
       * Добавляет один элемент в меню
       * @param {Object} item - Элемент меню для добавления
       */
        state.items.push(item)
    },
    selectInstance(state, name) {
      /**
       * Выбирает текущий экземпляр меню
       * @param {string} name - Имя экземпляра меню
       */
        state.currentInstance = name
    },
    activeRouterChange(state, activeRouterName) {
      /**
       * Обновляет активный маршрут для подсветки
       * @param {string} activeRouterName - Имя активного маршрута
       */
        state.activeRouter = activeRouterName
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    // actions,
}
